import { parse } from "postcss";
import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom";


import { API_URL, GET_DOWNLOAD_FILE, GET_ADMIN_FILES_RETURN_TABLE } from "../../../constants";
import { GET_TOKEN, OBJECT_EMPTY } from "../../../helpers";
import { LoadingSpinner } from "../../dashboard/partials/LoadingSpinner";
import { ReactTable } from "../../Global/ReactTable/ReactTable";
import { SelectInput } from "../../Global/SelectInput/SelectInput";
import { Modal } from "../../Global/Modal/Modal";
import { EmptyData } from "../../Global/EmptyData/EmptyData";

import "./UserReturns.css";

export const UserReturns = () => {
  const [pingTableRefresh, setPingTableRefresh] = useState(false);

  const [returnsType, setReturnsType] = useState('active');
  const [dataLoaded, setDataLoaded] = useState(false);
  const [modalActive, setModalActive] = useState(false);
  const [rejectModalActive, setRejectModalActive] = useState(false);
  
  const [returnsData, setReturnsData] = useState([]);
  const [instructionsTextbox, setInstructionsTextbox] = useState('');
  const [rejectionError, setRejectionError] = useState('');
  const [selectedID, setSelectedID] = useState({});
  const [statusValues, setStatusValues] = useState({});

  const ReturnsTypeSelectBoxValues = [
    {
      label: "Active Returns",
      value: 'active'
    },
    {
      label: "Archived",
      value: 'archive'
    },
  ]

  const ApprovalSelectBoxValues = [
    {
      label: "Approve",
      value: 'approved'
    },
    {
      label: "Reject",
      value: 'rejected'
    },
  ]

  const statusValuesList = [
    {
      label: "Waiting for data",
      value: 'waiting_for_data'
    },
    {
      label: "Waiting for approval",
      value: 'waiting_for_approval'
    },
    {
      label: "Approved",
      value: 'approved'
    },
    {
      label: "Rejected",
      value: 'rejected'
    },
    {
      label: "Checked",
      value: 'checked'
    },
    {
      label: "Waiting for data",
      value: 'created'
    },
    {
      label: "Waiting",
      value: 'waiting'
    },
    {
      label: "Processing",
      value: 'processing'
    },
  ]

  const fetchUserReturnsTable = () => {
    fetch(API_URL + GET_ADMIN_FILES_RETURN_TABLE + `?list=${returnsType}`, {
      method: "get",
      headers: new Headers({
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + GET_TOKEN(),
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        setReturnsData([...response])
      })
      .catch(err => console.log(err))
      .finally(() => setDataLoaded(true))
  }

  useEffect(() => {
    setDataLoaded(false)

    fetchUserReturnsTable()
  }, [returnsType, pingTableRefresh]);

  useEffect(() => {
    let fetchData = setInterval(() => fetchUserReturnsTable(), 30000);

    return () => clearInterval(fetchData)
  })

  const getFileBlob = (filePath, FileName, returnId) => {
    fetch(API_URL + `/returns/${returnId}/file/${filePath}`, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + GET_TOKEN(),
      }),
    })
      .then(res => res.blob())
      .then(blob => {
        if (filePath !== undefined ) {
          let file = window.URL.createObjectURL(blob);
          let a = document.createElement('a');

          a.setAttribute("id", "temprorary_CVS_link");
          document.body.appendChild(a);
          
          if (!window.navigator.msSaveOrOpenBlob) {
            a.href = file;
            a.download = FileName ? FileName : 'onestopvat.csv';
          }

          document.getElementById('temprorary_CVS_link').click()
        }
      })
      .then(() => document.getElementById('temprorary_CVS_link')?.remove())
      .catch(err => console.log(err));
  }

  const ReturnsTypeSelectBox = () => {
    return <SelectInput 
      selectValues={ReturnsTypeSelectBoxValues}
      value={ReturnsTypeSelectBoxValues.filter(item => item.value === returnsType)}
      inputValueHandler={(e) => setReturnsType(e.value)}
    />
  }

  const submitRejectionAction = () => {
    setRejectionError('')

    if (document.getElementById('rejectedreason')?.value.length > 20) {
      fetch(API_URL + GET_ADMIN_FILES_RETURN_TABLE + `/${selectedID.rowId}`, {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: "Bearer " + GET_TOKEN(),
        }),
        body: JSON.stringify({
          status: selectedID.selectValue.value,
          reject_reason: document.getElementById('rejectedreason')?.value
        }),
      })
        .then(() => setRejectModalActive(false))
        .then(() => document.getElementById('rejectedreason').value = '')
        .then(() => fetchUserReturnsTable())
        .catch(err => console.log(err))
    } else {
      setRejectionError('Please enter more detailed explanation')
    }

  }

  const selectAction = (selectValue, rowId) => {
    if (selectValue.value === 'rejected') {
      setSelectedID({selectValue, rowId})
      setRejectModalActive(true)

    } else {
      fetch(API_URL + GET_ADMIN_FILES_RETURN_TABLE + `/${rowId}`, {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: "Bearer " + GET_TOKEN(),
        }),
        body: JSON.stringify({
          status: selectValue.value,
          reject_reason: ''
        }),
      })
        // .then(() => setRejectionTextbox(''))
        .then(() => setRejectModalActive(false))
        .then(() => setReturnsType(returnsType))
        .then(() => fetchUserReturnsTable())
        .catch(err => console.log(err))
    }
  }

  const ApprovalSelectBox = (rowId) => {
    return <SelectInput 
      selectValues={ApprovalSelectBoxValues}
      inputValueHandler={(e) => selectAction(e, rowId)}
      placeholder='Select Action'
    />
  }

  const returnsColumns = [
    {
      Header: "Country",
      accessor: "country",
      className: "cell_country",
      Cell: (cell) => {
        return <div className="countryCell">
          <img src={cell.data[cell.row.id].country.img} alt="flag" className="flag-icon-img"/>
          {cell.data[cell.row.id].country.name}
        </div>
      }
    },
    {
      Header: "Return type",
      accessor: "return_type",
      className: "cell_type"
    },
    {
      Header: "Status",
      accessor: "status",
      className: "cell_status",
      Cell: (cell) => {
        let findValue = statusValuesList.filter(item => item.value === cell.value)[0] || []

        let value = (cell.value === undefined || cell.value === null)
          ? '-'
          : findValue ?? findValue.length > 0
            ? findValue.label
            : '-'

        return <div className={cell.value ? cell.value : ''}>
          {value}
        </div>
      }
    },
    {
      Header: "Period",
      accessor: "period",
      className: "cell_period"
    },
    {
      Header: "Instruction",
      accessor: "instruction",
      className: "cell_instruction",
      Cell: (cell) => {
        return <div className="instruction_wrapper">
          {cell.data[cell.row.id].instruction?.length > 0
            ? (
              <button 
                className='active'
                onClick={() => {
                  setInstructionsTextbox(cell.data[cell.row.id].instruction !== null ? cell.data[cell.row.id].instruction : '')
                  setModalActive(true)
                }}
              >
                <div className="icon info"/> View
              </button>
            )
            : <>-</>
          }
        </div>
      },
    },
    // {
    //   Header: "Instruction",
    //   accessor: "instruction",
    //   className: "cell_instruction",
    //   Cell: (cell) => {
    //     let instructions = cell.data[cell.row.id].country
    //     return <div className="instruction_wrapper">
          
    //     </div>
    //   },
    // },
    {
      Header: "Action needed",
      accessor: "action",
      className: "cell_status",
      Cell: (cell) => {
        let status = cell.data[cell.row.id].status

        return (
          status === 'waiting_for_approval'
            ? ApprovalSelectBox(cell.data[cell.row.id].id)
            : status === 'created'
              ? <Link to='/dashboard/userfileimport' exact="true">Upload</Link>
              : <>No action needed</>
        )
      },
    },
    {
      Header: "Download",
      accessor: "file_path",
      className: "cell_download",
      Cell: (cell) => {
        // console.log(cell.data[cell.row.id].file)
        let returnId = cell.data[cell.row.id].id
        let file_info = cell.data[cell.row.id].file

        return file_info !== null
          // ? <button className='download_button' onClick={() => getFileBlob(cell.value)} />
          ? <button className='download_button' onClick={() => getFileBlob(file_info.id, file_info.name, returnId)} />
          : <></>
      },
    },
  ];

  const ReturnsList = () => {
    return <ReactTable className="returnsDataListTable" columns={returnsColumns} data={returnsData} />
  }

  return (
    <div className='UserReturns'>
      <div className="Dashboard__content__top-row">
        <h2> Returns </h2>

        <ul className="Dashboard__content__top-row__selectors">
          <li>
            {ReturnsTypeSelectBox()}
          </li>
        </ul>
      </div>

      {dataLoaded 
        ? returnsData.length > 0 ? ReturnsList() : <EmptyData title="No returns data found" />
        : <LoadingSpinner/>
      }

      <Modal
        ModalOpenHandler={(value) => setModalActive(value)}
        ModalOpen={modalActive}
        ModalBgCloseDisabled={true}
        customClassName={'modal__read_instructions'}
        title={'Instructions'}
        closeButton
      >
        <div className="instructions">
          <div dangerouslySetInnerHTML={{__html: instructionsTextbox}}/>
        </div>
        <div className="button-wrapper">
          <button className='default_button close_read_instructions' onClick={() => setModalActive(false)}>Close</button>
        </div>
      </Modal>

      <Modal
        ModalOpenHandler={(value) => setRejectModalActive(value)}
        ModalOpen={rejectModalActive}
        ModalBgCloseDisabled={true}
        customClassName={'modal__reject_input'}
        // title={'Please Explain Rejection reason'}
        // closeButton
      >
        <div className="top_row flex-space-between flex-align-center">
          <h3>Please Explain Rejection reason</h3>
          <button className='default_button close_read_instructions' onClick={() => submitRejectionAction()}>Confirm and proceed</button>
        </div>

        <div className="instructions">
          {rejectionError && <h5 className="error-message">{rejectionError}</h5>}
          <textarea className={rejectionError ? 'field-error' : ''} name="rejectreason" id="rejectedreason" cols="30" rows="10"/>
        </div>
      </Modal>
    </div>
  );
};
